__turbopack_context__.v({
  "boxOne": "bento-two-module-scss-module__gpgARa__boxOne",
  "boxTwo": "bento-two-module-scss-module__gpgARa__boxTwo",
  "container": "bento-two-module-scss-module__gpgARa__container",
  "flexContainer": "bento-two-module-scss-module__gpgARa__flexContainer",
});
